// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file live178/v1/live.proto (package live178.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Money, OperationResult, PageRequest, PageResponse } from "./common_pb";
import { file_live178_v1_common } from "./common_pb";
import type { SportType } from "./sports_pb";
import { file_live178_v1_sports } from "./sports_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file live178/v1/live.proto.
 */
export const file_live178_v1_live: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_live178_v1_common, file_live178_v1_sports]);

/**
 * @generated from message live178.v1.StreamVariant
 */
export type StreamVariant = Message<"live178.v1.StreamVariant"> & {
  /**
   * @generated from field: string variant_id = 1;
   */
  variantId: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: int32 width = 3;
   */
  width: number;

  /**
   * @generated from field: int32 height = 4;
   */
  height: number;

  /**
   * @generated from field: int32 frames_per_second = 5;
   */
  framesPerSecond: number;

  /**
   * @generated from field: int64 bitrate_bps = 6;
   */
  bitrateBps: bigint;

  /**
   * @generated from field: string codec = 7;
   */
  codec: string;

  /**
   * @generated from field: string url = 8;
   */
  url: string;

  /**
   * @generated from field: string cdn = 9;
   */
  cdn: string;
};

/**
 * Describes the message live178.v1.StreamVariant.
 * Use `create(StreamVariantSchema)` to create a new message.
 */
export const StreamVariantSchema: GenMessage<StreamVariant> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 0);

/**
 * @generated from message live178.v1.PlaybackRights
 */
export type PlaybackRights = Message<"live178.v1.PlaybackRights"> & {
  /**
   * @generated from field: string region = 1;
   */
  region: string;

  /**
   * @generated from field: bool recording_allowed = 2;
   */
  recordingAllowed: boolean;

  /**
   * @generated from field: bool casting_allowed = 3;
   */
  castingAllowed: boolean;

  /**
   * @generated from field: bool picture_in_picture_allowed = 4;
   */
  pictureInPictureAllowed: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp rights_expire_at = 5;
   */
  rightsExpireAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.PlaybackRights.
 * Use `create(PlaybackRightsSchema)` to create a new message.
 */
export const PlaybackRightsSchema: GenMessage<PlaybackRights> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 1);

/**
 * @generated from message live178.v1.LiveRoom
 */
export type LiveRoom = Message<"live178.v1.LiveRoom"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string match_id = 2;
   */
  matchId: string;

  /**
   * @generated from field: string anchor_id = 3;
   */
  anchorId: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string cover_url = 5;
   */
  coverUrl: string;

  /**
   * @generated from field: live178.v1.LiveRoomStatus status = 6;
   */
  status: LiveRoomStatus;

  /**
   * @generated from field: int64 viewer_count = 7;
   */
  viewerCount: bigint;

  /**
   * @generated from field: repeated string tags = 8;
   */
  tags: string[];

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_at = 9;
   */
  scheduledAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 10;
   */
  startedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp ended_at = 11;
   */
  endedAt?: Timestamp | undefined;

  /**
   * @generated from field: int64 revision = 12;
   */
  revision: bigint;
};

/**
 * Describes the message live178.v1.LiveRoom.
 * Use `create(LiveRoomSchema)` to create a new message.
 */
export const LiveRoomSchema: GenMessage<LiveRoom> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 2);

/**
 * @generated from message live178.v1.Gift
 */
export type Gift = Message<"live178.v1.Gift"> & {
  /**
   * @generated from field: string gift_id = 1;
   */
  giftId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string image_url = 3;
   */
  imageUrl: string;

  /**
   * @generated from field: live178.v1.Money price = 4;
   */
  price?: Money | undefined;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled: boolean;

  /**
   * @generated from field: int32 display_order = 6;
   */
  displayOrder: number;
};

/**
 * Describes the message live178.v1.Gift.
 * Use `create(GiftSchema)` to create a new message.
 */
export const GiftSchema: GenMessage<Gift> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 3);

/**
 * @generated from message live178.v1.ListLiveRoomsRequest
 */
export type ListLiveRoomsRequest = Message<"live178.v1.ListLiveRoomsRequest"> & {
  /**
   * @generated from field: live178.v1.SportType sport = 1;
   */
  sport: SportType;

  /**
   * @generated from field: live178.v1.LiveRoomStatus status = 2;
   */
  status: LiveRoomStatus;

  /**
   * @generated from field: live178.v1.PageRequest page = 3;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListLiveRoomsRequest.
 * Use `create(ListLiveRoomsRequestSchema)` to create a new message.
 */
export const ListLiveRoomsRequestSchema: GenMessage<ListLiveRoomsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 4);

/**
 * @generated from message live178.v1.ListLiveRoomsResponse
 */
export type ListLiveRoomsResponse = Message<"live178.v1.ListLiveRoomsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.LiveRoom rooms = 1;
   */
  rooms: LiveRoom[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListLiveRoomsResponse.
 * Use `create(ListLiveRoomsResponseSchema)` to create a new message.
 */
export const ListLiveRoomsResponseSchema: GenMessage<ListLiveRoomsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 5);

/**
 * @generated from message live178.v1.GetLiveRoomRequest
 */
export type GetLiveRoomRequest = Message<"live178.v1.GetLiveRoomRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message live178.v1.GetLiveRoomRequest.
 * Use `create(GetLiveRoomRequestSchema)` to create a new message.
 */
export const GetLiveRoomRequestSchema: GenMessage<GetLiveRoomRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 6);

/**
 * @generated from message live178.v1.GetLiveRoomResponse
 */
export type GetLiveRoomResponse = Message<"live178.v1.GetLiveRoomResponse"> & {
  /**
   * @generated from field: live178.v1.LiveRoom room = 1;
   */
  room?: LiveRoom | undefined;

  /**
   * @generated from field: repeated live178.v1.StreamVariant preview_variants = 2;
   */
  previewVariants: StreamVariant[];
};

/**
 * Describes the message live178.v1.GetLiveRoomResponse.
 * Use `create(GetLiveRoomResponseSchema)` to create a new message.
 */
export const GetLiveRoomResponseSchema: GenMessage<GetLiveRoomResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 7);

/**
 * @generated from message live178.v1.CreatePlaybackGrantRequest
 */
export type CreatePlaybackGrantRequest = Message<"live178.v1.CreatePlaybackGrantRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string device_id = 2;
   */
  deviceId: string;

  /**
   * @generated from field: live178.v1.PlaybackProtocol preferred_protocol = 3;
   */
  preferredProtocol: PlaybackProtocol;

  /**
   * @generated from field: string client_region = 4;
   */
  clientRegion: string;
};

/**
 * Describes the message live178.v1.CreatePlaybackGrantRequest.
 * Use `create(CreatePlaybackGrantRequestSchema)` to create a new message.
 */
export const CreatePlaybackGrantRequestSchema: GenMessage<CreatePlaybackGrantRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 8);

/**
 * @generated from message live178.v1.CreatePlaybackGrantResponse
 */
export type CreatePlaybackGrantResponse = Message<"live178.v1.CreatePlaybackGrantResponse"> & {
  /**
   * @generated from field: string grant_id = 1;
   */
  grantId: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: live178.v1.PlaybackProtocol protocol = 3;
   */
  protocol: PlaybackProtocol;

  /**
   * @generated from field: repeated live178.v1.StreamVariant variants = 4;
   */
  variants: StreamVariant[];

  /**
   * @generated from field: live178.v1.PlaybackRights rights = 5;
   */
  rights?: PlaybackRights | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * @generated from field: int32 heartbeat_interval_seconds = 7;
   */
  heartbeatIntervalSeconds: number;
};

/**
 * Describes the message live178.v1.CreatePlaybackGrantResponse.
 * Use `create(CreatePlaybackGrantResponseSchema)` to create a new message.
 */
export const CreatePlaybackGrantResponseSchema: GenMessage<CreatePlaybackGrantResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 9);

/**
 * @generated from message live178.v1.PlaybackHeartbeatRequest
 */
export type PlaybackHeartbeatRequest = Message<"live178.v1.PlaybackHeartbeatRequest"> & {
  /**
   * @generated from field: string grant_id = 1;
   */
  grantId: string;

  /**
   * @generated from field: string room_id = 2;
   */
  roomId: string;

  /**
   * @generated from field: string variant_id = 3;
   */
  variantId: string;

  /**
   * @generated from field: int64 playhead_millis = 4;
   */
  playheadMillis: bigint;

  /**
   * @generated from field: int64 rebuffer_millis = 5;
   */
  rebufferMillis: bigint;

  /**
   * @generated from field: int32 dropped_frames = 6;
   */
  droppedFrames: number;
};

/**
 * Describes the message live178.v1.PlaybackHeartbeatRequest.
 * Use `create(PlaybackHeartbeatRequestSchema)` to create a new message.
 */
export const PlaybackHeartbeatRequestSchema: GenMessage<PlaybackHeartbeatRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 10);

/**
 * @generated from message live178.v1.PlaybackHeartbeatResponse
 */
export type PlaybackHeartbeatResponse = Message<"live178.v1.PlaybackHeartbeatResponse"> & {
  /**
   * @generated from field: bool continue_allowed = 1;
   */
  continueAllowed: boolean;

  /**
   * @generated from field: repeated live178.v1.StreamVariant replacement_variants = 2;
   */
  replacementVariants: StreamVariant[];
};

/**
 * Describes the message live178.v1.PlaybackHeartbeatResponse.
 * Use `create(PlaybackHeartbeatResponseSchema)` to create a new message.
 */
export const PlaybackHeartbeatResponseSchema: GenMessage<PlaybackHeartbeatResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 11);

/**
 * @generated from message live178.v1.StartBroadcastRequest
 */
export type StartBroadcastRequest = Message<"live178.v1.StartBroadcastRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string idempotency_key = 2;
   */
  idempotencyKey: string;
};

/**
 * Describes the message live178.v1.StartBroadcastRequest.
 * Use `create(StartBroadcastRequestSchema)` to create a new message.
 */
export const StartBroadcastRequestSchema: GenMessage<StartBroadcastRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 12);

/**
 * @generated from message live178.v1.StartBroadcastResponse
 */
export type StartBroadcastResponse = Message<"live178.v1.StartBroadcastResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.StartBroadcastResponse.
 * Use `create(StartBroadcastResponseSchema)` to create a new message.
 */
export const StartBroadcastResponseSchema: GenMessage<StartBroadcastResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 13);

/**
 * @generated from message live178.v1.StopBroadcastRequest
 */
export type StopBroadcastRequest = Message<"live178.v1.StopBroadcastRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;
};

/**
 * Describes the message live178.v1.StopBroadcastRequest.
 * Use `create(StopBroadcastRequestSchema)` to create a new message.
 */
export const StopBroadcastRequestSchema: GenMessage<StopBroadcastRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 14);

/**
 * @generated from message live178.v1.StopBroadcastResponse
 */
export type StopBroadcastResponse = Message<"live178.v1.StopBroadcastResponse"> & {
  /**
   * @generated from field: live178.v1.OperationResult result = 1;
   */
  result?: OperationResult | undefined;
};

/**
 * Describes the message live178.v1.StopBroadcastResponse.
 * Use `create(StopBroadcastResponseSchema)` to create a new message.
 */
export const StopBroadcastResponseSchema: GenMessage<StopBroadcastResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 15);

/**
 * @generated from message live178.v1.ListGiftsRequest
 */
export type ListGiftsRequest = Message<"live178.v1.ListGiftsRequest"> & {
};

/**
 * Describes the message live178.v1.ListGiftsRequest.
 * Use `create(ListGiftsRequestSchema)` to create a new message.
 */
export const ListGiftsRequestSchema: GenMessage<ListGiftsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 16);

/**
 * @generated from message live178.v1.ListGiftsResponse
 */
export type ListGiftsResponse = Message<"live178.v1.ListGiftsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.Gift gifts = 1;
   */
  gifts: Gift[];
};

/**
 * Describes the message live178.v1.ListGiftsResponse.
 * Use `create(ListGiftsResponseSchema)` to create a new message.
 */
export const ListGiftsResponseSchema: GenMessage<ListGiftsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 17);

/**
 * @generated from message live178.v1.SendGiftRequest
 */
export type SendGiftRequest = Message<"live178.v1.SendGiftRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;

  /**
   * @generated from field: string gift_id = 2;
   */
  giftId: string;

  /**
   * @generated from field: int32 quantity = 3;
   */
  quantity: number;

  /**
   * @generated from field: string client_request_id = 4;
   */
  clientRequestId: string;
};

/**
 * Describes the message live178.v1.SendGiftRequest.
 * Use `create(SendGiftRequestSchema)` to create a new message.
 */
export const SendGiftRequestSchema: GenMessage<SendGiftRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 18);

/**
 * @generated from message live178.v1.SendGiftResponse
 */
export type SendGiftResponse = Message<"live178.v1.SendGiftResponse"> & {
  /**
   * @generated from field: string gift_transaction_id = 1;
   */
  giftTransactionId: string;

  /**
   * @generated from field: live178.v1.Money total = 2;
   */
  total?: Money | undefined;

  /**
   * @generated from field: live178.v1.Money wallet_balance = 3;
   */
  walletBalance?: Money | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp sent_at = 4;
   */
  sentAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.SendGiftResponse.
 * Use `create(SendGiftResponseSchema)` to create a new message.
 */
export const SendGiftResponseSchema: GenMessage<SendGiftResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 19);

/**
 * @generated from message live178.v1.GetStreamHealthRequest
 */
export type GetStreamHealthRequest = Message<"live178.v1.GetStreamHealthRequest"> & {
  /**
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message live178.v1.GetStreamHealthRequest.
 * Use `create(GetStreamHealthRequestSchema)` to create a new message.
 */
export const GetStreamHealthRequestSchema: GenMessage<GetStreamHealthRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 20);

/**
 * @generated from message live178.v1.StreamHealth
 */
export type StreamHealth = Message<"live178.v1.StreamHealth"> & {
  /**
   * @generated from field: string input_id = 1;
   */
  inputId: string;

  /**
   * @generated from field: string state = 2;
   */
  state: string;

  /**
   * @generated from field: double ingest_frames_per_second = 3;
   */
  ingestFramesPerSecond: number;

  /**
   * @generated from field: double audio_level = 4;
   */
  audioLevel: number;

  /**
   * @generated from field: int64 manifest_age_millis = 5;
   */
  manifestAgeMillis: bigint;

  /**
   * @generated from field: double segment_error_rate = 6;
   */
  segmentErrorRate: number;

  /**
   * @generated from field: google.protobuf.Timestamp sampled_at = 7;
   */
  sampledAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.StreamHealth.
 * Use `create(StreamHealthSchema)` to create a new message.
 */
export const StreamHealthSchema: GenMessage<StreamHealth> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 21);

/**
 * @generated from message live178.v1.GetStreamHealthResponse
 */
export type GetStreamHealthResponse = Message<"live178.v1.GetStreamHealthResponse"> & {
  /**
   * @generated from field: repeated live178.v1.StreamHealth samples = 1;
   */
  samples: StreamHealth[];
};

/**
 * Describes the message live178.v1.GetStreamHealthResponse.
 * Use `create(GetStreamHealthResponseSchema)` to create a new message.
 */
export const GetStreamHealthResponseSchema: GenMessage<GetStreamHealthResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_live, 22);

/**
 * @generated from enum live178.v1.LiveRoomStatus
 */
export enum LiveRoomStatus {
  /**
   * @generated from enum value: LIVE_ROOM_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LIVE_ROOM_STATUS_SCHEDULED = 1;
   */
  SCHEDULED = 1,

  /**
   * @generated from enum value: LIVE_ROOM_STATUS_LIVE = 2;
   */
  LIVE = 2,

  /**
   * @generated from enum value: LIVE_ROOM_STATUS_PAUSED = 3;
   */
  PAUSED = 3,

  /**
   * @generated from enum value: LIVE_ROOM_STATUS_ENDED = 4;
   */
  ENDED = 4,

  /**
   * @generated from enum value: LIVE_ROOM_STATUS_BLOCKED = 5;
   */
  BLOCKED = 5,
}

/**
 * Describes the enum live178.v1.LiveRoomStatus.
 */
export const LiveRoomStatusSchema: GenEnum<LiveRoomStatus> = /*@__PURE__*/
  enumDesc(file_live178_v1_live, 0);

/**
 * @generated from enum live178.v1.PlaybackProtocol
 */
export enum PlaybackProtocol {
  /**
   * @generated from enum value: PLAYBACK_PROTOCOL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAYBACK_PROTOCOL_HLS = 1;
   */
  HLS = 1,

  /**
   * @generated from enum value: PLAYBACK_PROTOCOL_LOW_LATENCY_HLS = 2;
   */
  LOW_LATENCY_HLS = 2,

  /**
   * @generated from enum value: PLAYBACK_PROTOCOL_WEBRTC = 3;
   */
  WEBRTC = 3,

  /**
   * @generated from enum value: PLAYBACK_PROTOCOL_PROGRESSIVE = 4;
   */
  PROGRESSIVE = 4,
}

/**
 * Describes the enum live178.v1.PlaybackProtocol.
 */
export const PlaybackProtocolSchema: GenEnum<PlaybackProtocol> = /*@__PURE__*/
  enumDesc(file_live178_v1_live, 1);

/**
 * @generated from service live178.v1.LiveService
 */
export const LiveService: GenService<{
  /**
   * @generated from rpc live178.v1.LiveService.ListLiveRooms
   */
  listLiveRooms: {
    methodKind: "unary";
    input: typeof ListLiveRoomsRequestSchema;
    output: typeof ListLiveRoomsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.LiveService.GetLiveRoom
   */
  getLiveRoom: {
    methodKind: "unary";
    input: typeof GetLiveRoomRequestSchema;
    output: typeof GetLiveRoomResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.LiveService.CreatePlaybackGrant
   */
  createPlaybackGrant: {
    methodKind: "unary";
    input: typeof CreatePlaybackGrantRequestSchema;
    output: typeof CreatePlaybackGrantResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.LiveService.PlaybackHeartbeat
   */
  playbackHeartbeat: {
    methodKind: "unary";
    input: typeof PlaybackHeartbeatRequestSchema;
    output: typeof PlaybackHeartbeatResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.LiveService.StartBroadcast
   */
  startBroadcast: {
    methodKind: "unary";
    input: typeof StartBroadcastRequestSchema;
    output: typeof StartBroadcastResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.LiveService.StopBroadcast
   */
  stopBroadcast: {
    methodKind: "unary";
    input: typeof StopBroadcastRequestSchema;
    output: typeof StopBroadcastResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.LiveService.ListGifts
   */
  listGifts: {
    methodKind: "unary";
    input: typeof ListGiftsRequestSchema;
    output: typeof ListGiftsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.LiveService.SendGift
   */
  sendGift: {
    methodKind: "unary";
    input: typeof SendGiftRequestSchema;
    output: typeof SendGiftResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.LiveService.GetStreamHealth
   */
  getStreamHealth: {
    methodKind: "unary";
    input: typeof GetStreamHealthRequestSchema;
    output: typeof GetStreamHealthResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_live178_v1_live, 0);

